export let loadJSON = url => {
	return new Promise((resolve, reject) => {
		var req = new XMLHttpRequest()
		req.overrideMimeType('application/json')
		req.open('GET', url, true)
		req.onreadystatechange = () => {
			if (req.readyState == 4 && req.status == '200')
				resolve(JSON.parse(req.responseText))
			if (req.status != '200')
				reject(Error("Couldn't load the JSON file"))
		}
		req.send(null)
	})
}



// WEBPACK FOOTER //
// ./src/jsonLoader.js